const $ = window.jQuery || {};

class CurrencyCalculator {
  constructor() {
    this.exchangeRate = 2.92; // Default rate until fetched
    this.serviceFeePercentage = 0.2; // 20% fee
    this.init();
  }

  // Initialize calculator and fetch exchange rate
  init() {
    this.fetchExchangeRate();
    this.attachEventListeners();
  }

  // Fetch exchange rate from backend using Ajax
  fetchExchangeRate() {
    $.ajax({
      url: "/wp-admin/admin-ajax.php",
      method: "POST",
      data: {
        action: "fetch_exchange_rate",
      },
      success: (response) => {
        this.exchangeRate = parseFloat(response.data) || this.exchangeRate;
        this.updateCalculation();
      },
      error: (err) => {
        console.error("Failed to fetch exchange rate", err);
      },
    });
  }

  // Attach event listeners to form
  attachEventListeners() {
    const self = this;
    $("body").on("input paste change", "#orderPrice", function () {
      self.updateCalculation();
    });
  }

  // Update the RUB amount on form change
  updateCalculation() {
    const orderPrice = parseFloat($("#orderPrice").val()) || 0;
    const serviceFee = orderPrice * this.serviceFeePercentage;
    const totalPrice = (orderPrice + serviceFee) * this.exchangeRate;
    if (totalPrice) {
      if (totalPrice < 0) {
        return;
      }
      const totalPriceCurrencyFormatted = totalPrice
        .toFixed(2)
        .replace(/\d(?=(\d{3})+\.)/g, "$&,");
      $("#rubAmount").text(totalPriceCurrencyFormatted + " руб.");
    }
  }
}

export default CurrencyCalculator;
